import React from 'react';
import { fleetRoute } from '@/modules/fleet/route';
import { createRoute } from '@tanstack/react-router';

export const fleetMapRoute = createRoute({
  getParentRoute: () => fleetRoute,
  path: 'map',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Fleet/MapTab')),
});
